import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { ParticipantAccountActivitySummaryReportParams } from '../ParticipantActivityReport.types';

export const QUERY_KEY = 'EXPORT_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_SUMMARY_CSV';
const useParticipantAccountActivityReportExportSummaryCSVQuery = (
  params: ParticipantAccountActivitySummaryReportParams
) => {
  const getEmployerIdParam = useGetEmployerIdParam();
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const { refetch, isSuccess } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(
        params.isMultipleEmployer
          ? API_URL.REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV
          : API_URL.REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_SUMMARY_EXPORT_CSV,
        {
          params: _.pickBy({
            ...getEmployerIdParam(params.employerId, params.employerIds),
            plan_year_period:
              params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
                ? params?.planYearPeriod.join(',')
                : undefined,
            plan_ids:
              params?.planIds && !params?.planIds.includes(ALL_OPTION_KEY)
                ? params?.planIds.join(',')
                : undefined,
          }),
        }
      ),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response.data?.data, 'csv', 'participant_account_activity_summary');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
    isSuccess,
  };
};

export default useParticipantAccountActivityReportExportSummaryCSVQuery;
